import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material";

import Section from "../../../common/components/layout/utils/Section";
import RenderArticleWithFadeEffect from "../../../common/components/rich-text-renderer/RenderArticleWithFadeEffect";

const WhatYouWillLearn: React.FC<{ content: string }> = ({ content }) => {
  const theme = useTheme();

  return (
    <Section boxProps={{ pb: 12 }}>
      <Box
        sx={{ width: "60%", [theme.breakpoints.down("sm")]: { width: "100%" } }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            pb: { xs: 2, md: 4 },
            [theme.breakpoints.down("sm")]: { fontSize: 18 },
          }}
        >
          What you will learn?
        </Typography>
        <RenderArticleWithFadeEffect content={content} />
      </Box>
    </Section>
  );
};

export default WhatYouWillLearn;
